import React, { useEffect, useState } from "react";
import { client } from "../sanityClient";
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

const SubNavbar = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        client
            .fetch(
                `*[_type == "productCategory" && !defined(parentCategory)]{
                    _id, title, slug,
                    "subCategories": *[_type == "productCategory" && parentCategory._ref == ^._id]{
                        _id, title, slug
                    }
                }`
            )
            .then(setCategories)
            .catch(console.error);
    }, []);

    return (
        <>
            {/* Navbar dưới Header */}
            <nav className="hidden lg:block bg-white shadow-md">
                <div className="container mx-auto flex justify-center py-2">
                    <ul className="flex space-x-6">
                        {categories.map((category) => (
                            <li key={category._id} className="relative group">
                                <Link
                                    to={`/products?category=${category._id}`}
                                    className="text-gray-800 font-semibold uppercase text-[0.9rem] tracking-tight  hover:text-[#33367b] flex items-center space-x-1"
                                >
                                    <span>{category.title}</span>
                                    {category.subCategories.length > 0 && (
                                        <FaChevronDown className=" text-sm text-gray-800 group-hover:text-[#33367b]" />
                                    )}
                                </Link>

                                {/* Dropdown menu cho thể loại Con */}
                                {category.subCategories.length > 0 && (
                                    <ul className="absolute left-0 mt-2 w-48 bg-white border-x border-indigo-800 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        {category.subCategories.map((sub) => (
                                            <li key={sub._id}>
                                                <Link
                                                    to={`/products?category=${sub._id}`}
                                                    className="block px-2 py-2 text-gray-800 font-medium text-sm uppercase hover:bg-[#33367b] hover:text-white"
                                                >
                                                    {sub.title}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </nav>
        </>
    );
};

export default SubNavbar;
